const AnimationTypes = [
  'bounce',
  'flash',
  'pulse',
  'rubberBand',
  'shake',
  'swing',
  'tada',
  'wobble',
  'bounceInLeft',
  'bounceIn',
  'bounceInRight',
  'bounceInUp',
  'bounceInDown',
  'bounceOutLeft',
  'bounceOut',
  'bounceOutRight',
  'bounceOutUp',
  'bounceOutDown',
  'fadeIn',
  'fadeInDown',
  'fadeInDownBig',
  'fadeInLeft',
  'fadeInLeftBig',
  'fadeInUp',
  'fadeInRight',
  'fadeInRightBig',
  'fadeInUpBig',
  'fadeOut',
  'fadeOutDown',
  'fadeOutDownBig',
  'fadeOutLeft',
  'fadeOutLeftBig',
  'fadeOutUp',
  'fadeOutRight',
  'fadeOutRightBig',
  'fadeOutUpBig',
  'flipInX',
  'flip',
  'flipInY',
  'flipOutX',
  'flipOutY',
  'lightSpeedIn',
  'lightSpeedOut',
  'rotateInDownLeft',
  'rotateIn',
  'rotateInDownRight',
  'rotateInUpLeft',
  'rotateInUpRight',
  'rotateOutDownLeft',
  'rotateOut',
  'rotateOutDownRight',
  'rotateOutUpLeft',
  'rotateOutUpRight',
  'rollIn',
  'hinge',
  'rollOut',
  'zoomInLeft',
  'zoomIn',
  'zoomInRight',
  'zoomInUp',
  'zoomInDown',
  'zoomOutLeft',
  'zoomOut',
  'zoomOutRight',
  'zoomOutUp',
  'zoomOutDown'
];

export default AnimationTypes;
